import React from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { Endpoints } from 'UI/constants/endpoints';
import { UIStatus } from 'UI/constants/status';

import { SendoutNotesTabContent } from '../SendoutNotesTabContent';

const QUERY_PARAMS = 'includes=createdBy&orderBy=updatedAt';

export const SendoutNotesTabLoader = ({ sendoutId, canManageSendout }) => {
  const { state, refreshData } = useFetchWithStatusV2({
    endpoint: sendoutId
      ? `${Endpoints.SendoutsNotes.replace(':id', sendoutId)}?${QUERY_PARAMS}`
      : null,
    apiVersion: 2
  });
  const isLoading = state.status === UIStatus.Loading;
  const canRenderContent = [UIStatus.Success, UIStatus.Empty].includes(state.status);

  return (
    <>
      <When condition={isLoading}>
        <Box display="flex" justifyContent="center" alignItems="center" paddingY={4}>
          <CircularProgress />
        </Box>
      </When>

      <When condition={state.status === UIStatus.Error}>
        <EmptyPlaceholder
          title={strings.shared.errors.serverError.title}
          subtitle={strings.shared.errors.serverError.subtitle}
        />
      </When>

      <When condition={canRenderContent}>
        <SendoutNotesTabContent
          canManageSendout={canManageSendout}
          notes={state.results}
          refreshData={refreshData}
          sendoutId={sendoutId}
        />
      </When>
    </>
  );
};
